<template>
  <div>
    <span
      v-for="(n,i) in (articleParts.length > dataParts.length ? dataParts.length : articleParts.length)"
      :key="i"
    >
      <viewer :key="articleParts[i]" :initialValue="articleParts[i]"/>
      <TxBrowser :key="dataParts[i]" :setShare="dataParts[i]" standAlone/>
    </span>
    <viewer
      v-if="articleParts.length > dataParts.length"
      :key="articleParts[articleParts.length - 1]"
      :initialValue="articleParts[articleParts.length - 1]"
    />
    <TxBrowser
      v-if="articleParts.length < dataParts.length"
      :key="dataParts[dataParts.length - 1]"
      :setShare="dataParts[dataParts.length - 1]"
      standAlone
    />
  </div>
</template>

<script>
import TxBrowser from '@mcity/mcity-tx-browser/TxBrowser'
import '@toast-ui/editor/dist/toastui-editor-viewer.css'
import { Viewer } from '@toast-ui/vue-editor'
import 'highlight.js/styles/github.css'
import { mapState } from 'vuex'
export default {
  components: {
    TxBrowser,
    Viewer
  },
  data () {
    return {
      articleParts: [],
      dataParts: [],
      path: ''
    }
  },
  methods: {
    instantiateArticle () {
      document.title = this.currentArticle.title ? `${this.currentArticle.title} — Mcity Members` : 'Mcity Members'
      const regex = /\$\$\w+\$\$/g
      const endRegex = /\$\$/g
      this.articleParts = []
      this.dataParts = []
      let substring = this.currentArticle.content
      while (substring.search(regex) !== -1) {
        const idx = substring.search(regex)
        if (idx !== 0) {
          this.articleParts.push(substring.substr(0, idx))
        }
        const postDataIdx = substring.substr(idx + 2).search(endRegex) + 4
        this.dataParts.push(substring.substr(idx + 2, postDataIdx - 4))
        substring = substring.substr(idx + postDataIdx).trim()
      }
      if (substring.length > 0) {
        this.articleParts.push(substring)
      }
    }
  },
  computed: {
    ...mapState('article', {
      currentArticle: state => state.currentArticle
    })
  },
  mounted () {
    this.instantiateArticle()
  },
  watch: {
    currentArticle () {
      this.instantiateArticle()
    }
  }
}
</script>

<style>
</style>
